import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row } from './Layout';

interface LanguageSelectModalProps {
    onClose: () => void;
}

const LANGUAGES = [
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'ja', name: '日本語', flag: '🇯🇵' },
];

export const LanguageSelectModal: React.FC<LanguageSelectModalProps> = ({ onClose }) => {
    const { i18n } = useTranslation();
    const pointerStartY = React.useRef<number | null>(null);
    const isDrag = React.useRef(false);

    const changeLanguage = (code: string) => {
        localStorage.setItem('appLanguage', code);
        i18n.changeLanguage(code);
        onClose();
    };

    return (
        <div style={{ position: 'fixed', inset: 0, zIndex: 99999, display: 'flex', flexDirection: 'column' }}>
            <div onClick={onClose} style={{
                position: 'absolute', inset: 0,
                background: 'rgba(0,0,0,0.65)',
                backdropFilter: 'blur(5px)',
                animation: 'overlayIn .3s ease'
            }} />

            <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                background: 'var(--surface)',
                borderTopLeftRadius: 30, borderTopRightRadius: 30,
                borderTop: '1px solid var(--border)',
                height: '60vh', display: 'flex', flexDirection: 'column',
                animation: 'slideUpModal .4s cubic-bezier(0.16, 1, 0.3, 1)',
                zIndex: 10
            }}>
                <div style={{ padding: '20px', borderBottom: '1px solid var(--border)', flexShrink: 0 }}>
                    <div style={{ width: 40, height: 4, background: 'var(--border)', borderRadius: 2, margin: '0 auto 15px' }} />
                    <Row style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                        <div className="syne" style={{ fontSize: 20, fontWeight: 800 }}>Dil Seçimi</div>
                        <button onClick={onClose} className="icon-btn">✕</button>
                    </Row>
                </div>

                <div style={{ flex: 1, overflowY: 'auto', padding: '10px 20px' }}>
                    {LANGUAGES.map((lang) => {
                        const isSelected = i18n.language === lang.code;
                        return (
                            <button
                                key={lang.code}
                                onPointerDown={(e) => {
                                    pointerStartY.current = e.clientY;
                                    isDrag.current = false;
                                }}
                                onPointerMove={(e) => {
                                    if (pointerStartY.current !== null && Math.abs(e.clientY - pointerStartY.current) > 10) {
                                        isDrag.current = true;
                                    }
                                }}
                                onPointerUp={(e) => {
                                    if (pointerStartY.current !== null && Math.abs(e.clientY - pointerStartY.current) > 10) {
                                        isDrag.current = true;
                                    }
                                }}
                                onPointerCancel={() => {
                                    isDrag.current = true;
                                }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (isDrag.current) {
                                        isDrag.current = false;
                                        return;
                                    }
                                    changeLanguage(lang.code);
                                }}
                                style={{
                                    display: 'flex',
                                    width: '100%',
                                    padding: '16px',
                                    borderRadius: 16,
                                    marginBottom: 8,
                                    background: isSelected ? 'rgba(0,229,204,.1)' : 'transparent',
                                    border: `1px solid ${isSelected ? 'rgba(0,229,204,.3)' : 'transparent'}`,
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    transition: 'all .2s',
                                    userSelect: 'none',
                                    WebkitUserSelect: 'none',
                                    WebkitTapHighlightColor: 'transparent',
                                    fontFamily: 'inherit',
                                    textAlign: 'left'
                                }}
                            >
                                <div style={{ display: 'flex', gap: 12, alignItems: 'center', pointerEvents: 'none' }}>
                                    <div style={{ fontSize: 22 }}>{lang.flag}</div>
                                    <div style={{ fontSize: 16, fontWeight: isSelected ? 700 : 500, color: isSelected ? 'var(--cyan)' : 'var(--text)' }}>
                                        {lang.name}
                                    </div>
                                </div>
                                {isSelected && (
                                    <div style={{ width: 22, height: 22, borderRadius: '50%', background: 'var(--cyan)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#000', fontSize: 12, fontWeight: 'bold', pointerEvents: 'none' }}>
                                        ✓
                                    </div>
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
